export default "__VITE_ASSET__4TRTGTS5__"